<script setup>
const props = defineProps({
    user: {
        type: Object,
        default: null,
    },
    enrollmentHistory: {
        type: Array,
        default: () => [],
    },
});

const headers = [
    { text: "Start", value: "start", width: "120px" },
    { text: "End", value: "end", width: "120px" },
    { text: "Teacher", value: "teacher_name", width: "180px" },
    { text: "Program", value: "program_name", width: "140px" },
    { text: "Location", value: "location_name" },
    { text: "Instrument", value: "instrument_name" },
    { text: "Group Event", value: "group_event_name" },
    { text: "Price", value: "unit_amount" },
    { text: "Duration", value: "duration" },
];
</script>
<template>
    <v-simple-table>
        <tbody>
            <tr v-for="(item, index) in enrollmentHistory" :key="item.id">
                <td class="px-1 py-3">
                    <div
                        :class="item.end ? 'soli-status-red' : 'accent'"
                        class="soli-round"
                        style="width: 3px; height: 64px"
                    ></div>
                </td>
                <td>
                    <div class="caption soli-grey">
                        {{ `${item.start} - ${item.end ?? "Now"}` }}
                    </div>
                    <div
                        :class="
                            $vuetify.breakpoint.xsOnly ? 'body-2' : 'body-1'
                        "
                        class="soli-grey"
                    >
                        {{
                            item.group_event_name ??
                            `${item.instrument_name} Lessons`
                        }}
                    </div>
                    <div class="caption soli-grey flex whitespace-nowrap">
                        <div class="overflow-hidden clip-text">
                            {{ `${item.teacher_name}&nbsp` }}
                        </div>
                        <div
                            v-if="!item.group_event_name"
                            class="caption soli-grey"
                        >
                            · {{ item.duration }} min&nbsp;
                        </div>
                        <div class="caption soli-grey">
                            · {{ item.location_name }}
                        </div>
                        <div
                            v-if="item.group_event_name && item.instrument_name"
                            class="caption soli-grey"
                        >
                            · {{ item.instrument_name }}
                        </div>
                    </div>
                </td>
                <td class="soli-grey">{{ item.formatAmount }}/month</td>
            </tr>
        </tbody>
    </v-simple-table>
</template>
